/**
 * Store: Headers
 * -----------------------------------------------------------------------------
 * Manages states relating to the header elements.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    headerHeight: 0,
    preHeaderDismissed: null,
    visibleHeight: 0,
  }),

  mutations: {

    /**
     * Set header dismissed status.
     * @param {String} headerStatus - Whether the header is dismissed or not.
     * - Takes in an ID that can be changed to make the banner display again.
     */
    SET_PREHEADER_DISMISSED(state, headerStatus) {
      state.preHeaderDismissed = headerStatus
    },

    /**
     * Set header visible height.
     * @param {String} height - Visible height of the header.
     */
    SET_VISIBLE_HEIGHT(state, height) {
      state.visibleHeight = height
    },

    /**
     * Set header visible height.
     * @param {String} height - Visible height of the header.
     */
    SET_HEADER_HEIGHT(state, height) {
      state.headerHeight = height
    },
  },

  actions: {

    /**
     * Update the preheader dismissed status.
     * @param {String} headerStatus - Preheader status.
     * - Takes in an ID that can be changed to make the banner display again.
     */
    setPreheaderDismissedStatus({ commit }, headerStatus) {
      commit('SET_PREHEADER_DISMISSED', headerStatus)
    },

    /**
     * Actions the setting of header visible height to state.
     * @param {String} height - Visible height of the header.
     */
    setHeaderVisibleHeight({ commit }, height) {
      commit('SET_VISIBLE_HEIGHT', height)
    },

    /**
     * Actions the setting of header height to state.
     * @param {String} height - Height of the header whether visible or not.
     */
    setHeaderHeight({ commit }, height) {
      commit('SET_HEADER_HEIGHT', height)
    },
  },
}
